var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthOutlineHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7822 11.6094H10.9432C10.2113 11.6094 9.61719 12.2034 9.61719 12.9354V15.4616",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 9.61841H3.70021C4.08344 9.61841 4.44147 9.42679 4.65431 9.10721L5.29943 8.14052C5.51227 7.82094 5.8703 7.62932 6.25353 7.62932H6.25685C6.6918 7.62932 7.08895 7.87464 7.28322 8.26318L7.31239 8.32152C7.50666 8.71006 7.90381 8.95538 8.3381 8.95538H8.47137C9.10456 8.95538 9.61841 8.44219 9.61841 7.80834V7.80767C9.61841 7.3051 9.93931 6.85888 10.416 6.70042L10.9272 6.53002C11.333 6.39476 11.6075 6.01418 11.6075 5.58653V5.30872C11.6075 4.75973 11.1619 4.31417 10.613 4.31417C10.0633 4.31417 9.61841 3.86862 9.61841 3.31963V1.125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5866 8.29332C15.5866 12.3212 12.3212 15.5866 8.29332 15.5866C4.26542 15.5866 1 12.3212 1 8.29332C1 4.26542 4.26542 1 8.29332 1C12.3212 1 15.5866 4.26542 15.5866 8.29332Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthOutlineHome);
export default __webpack_public_path__ + "static/media/earth-outline-home.f34ecb46bd38817cf5646399220491b1.svg";
export { ForwardRef as ReactComponent };